<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container p-0">
    <div v-if="progressInfos">
      <div class="mb-2"
           v-for="(progressInfo, index) in progressInfos"
           :key="index">
        <span>{{progressInfo.fileName}}</span>
        <div class="progress">
          <div class="progress-bar progress-bar-info"
               role="progressbar"
               :aria-valuenow="progressInfo.percentage"
               aria-valuemin="0"
               aria-valuemax="100"
               :style="{ width: progressInfo.percentage + '%' }">
            {{progressInfo.percentage}}%
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-1" v-if="visible == true">
      <div class="col-4">
        <input type="file" multiple @change="selectFile" class="form-control h-auto" />
      </div>
      <div class="col-4">
        <button class="btn skin primary-button"
                :disabled="!selectedFiles"
                @click="uploadFiles">
          {{buttontext}}
        </button>
      </div>
    </div>

    <div v-if="message" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12 ml-0 pl-0 upload-files-container">
        <div class="col-12 ml-0 pl-0 upload-header">{{filestitle}}</div>
        <ul class="col-12 ml-0 pl-0 upload-filelist">
          <li class="col-12 ml-0 pl-0 upload-filelist-item"
              v-for="(file, index) in fileInfos"
              :key="index">
            <a :href="file.url">{{ file.name }}</a>
          </li>
        </ul>
      </div>
    </div>
    
  </div>
</template>

<script>


import UploadService from "../services/UploadFilesService";

  var filestitle = "";
  var buttontext = "";

export default {
  name: "upload-files",
    props: {
      
      uid: {
        type: String,
        default: null
      },
      visibility: {
        type: Boolean,
        default: true
      },
      filter: {
        type: String,
        default: null
      }
    },
  data() {
    return {
      filestitle,
      buttontext,
      selectedFiles: undefined,
      progressInfos: [],
      message: "",
      fileInfos: [],
      visible: this.visibility
    };
  },
  methods: {
    selectFile(event) {
      this.progressInfos = [];
      this.selectedFiles = event.target.files;
    },

    upload(uid, idx, file) {
      this.progressInfos[idx] = { percentage: 0, fileName: file.name };

      UploadService.upload(uid, file, null, null, "", false, false, (event) => {
        this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
      })
        .then((response) => {
          let prevMessage = this.message ? this.message + "\n" : "";
          this.message = prevMessage + response.data.message;

          return UploadService.getFiles(uid);
        })
        .then((files) => {
          this.fileInfos = files.data;
        })
        .catch(() => {
          this.progressInfos[idx].percentage = 0;
          this.message = "Could not upload the file:" + file.name;
        });
    },

    uploadFiles() {
      this.message = "";
      if (this.selectedFiles == null || this.selectedFiles.length == 0)
        return;

      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.upload(this.uid, i, this.selectedFiles[i]);
      }
      e.preventDefault();
      return false;
    }
  },
  mounted() {
    UploadService.getFiles(this.uid).then((response) => {
      this.fileInfos = response.data;
    });
    
    this.filestitle = this.$t('list_of_files');
    this.buttontext = this.$t('upload');

  }
};
</script>



// WEBPACK FOOTER //
// src/components/upload/upload-files.vue